import { render, staticRenderFns } from "./BasicsForm.vue?vue&type=template&id=a923c39a&scoped=true&"
import script from "./BasicsForm.vue?vue&type=script&lang=js&"
export * from "./BasicsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a923c39a",
  null
  
)

export default component.exports